import React from 'react';

const VISIBLE_WORD_COUNT = 4;

const SeedPhraseReveal = ({ words }) => {
  const tokens = (words || '').trim().split(/\s+/).filter(Boolean);

  if (tokens.length === 0) {
    return <span className="dash-seed-phrase-text">—</span>;
  }

  const visible = tokens.slice(0, VISIBLE_WORD_COUNT);
  const hidden = tokens.slice(VISIBLE_WORD_COUNT);

  return (
    <span className="dash-seed-phrase">
      <span className="dash-seed-phrase-text">{visible.join(' ')}</span>
      {hidden.length > 0 && (
        <span className="dash-seed-phrase-blur" aria-hidden="true">{hidden.join(' ')}</span>
      )}
    </span>
  );
};

export default SeedPhraseReveal;
